import { createFileRoute, useNavigate, useSearch } from '@tanstack/react-router'
import { History, Wallet } from 'lucide-react'

import { HomeContentContainer } from '@/components'
import { BillManagementList } from '@/components/pages/Admin/BillManagement/List'
import { Button } from '@/components/ui'
import { useTranslations } from '@/hooks/useTranslations'

export const Route = createFileRoute('/(dashboard)/admin/outstanding/')({
  component: OutstandingPage,
})

function OutstandingPage() {
  const t = useTranslations('admin.outstanding_management')
  const navigate = useNavigate()
  const searchParams = useSearch({ strict: false }) as { tab?: string; q?: string }
  const tab = searchParams.tab === 'sell' ? 'sell' : 'buy'

  return (
    <HomeContentContainer title={t('title')}>
      <div className="mb-4 flex flex-wrap justify-end gap-2">
        <Button
          type="button"
          variant="outline"
          className="w-full sm:w-auto"
          onClick={() => navigate({ to: '/admin/outstanding/history' })}
        >
          <History className="mr-2 h-4 w-4 shrink-0" aria-hidden />
          {t('btn_bulk_history')}
        </Button>
        <Button
          type="button"
          variant="default"
          className="w-full sm:w-auto"
          onClick={() =>
            navigate({
              to: '/admin/outstanding/settle',
              search: { tab },
            })
          }
        >
          <Wallet className="mr-2 h-4 w-4 shrink-0" aria-hidden />
          {t('btn_bulk_settle')}
        </Button>
      </div>
      <BillManagementList type="pending" />
    </HomeContentContainer>
  )
}

